import Icon from 'components/base/Icon';
import useConfirmModal from 'components/hooks/useConfirmModal';
import { LBButton } from '@linearb/buzz';

const RevertToDefault = ({ onClick }) => {
  const confirmModal = useConfirmModal();

  const _onClick = async () => {
    const isConfirmed = await confirmModal({
      title: 'Revert to default?',
      description:
        'Would you like to revert Insights configuration to default?',
      confirmText: 'Revert'
    });
    if (!isConfirmed) return;

    onClick();
  };
  return (
    <LBButton onClick={_onClick} variant='outline'>
      <Icon name='Refresh' />
      Revert to Default
    </LBButton>
  );
};

export default RevertToDefault;
